<template>
  <div
    :style="{...getPosition, ...highlight}"
    :class="[{'prevent-select': isDrag}, {'is-active': isActive}, {'is-focus': isFocus}, `--${col.sid}--flex-col-el`, col.hoverAnimation]"
    class="col-hover-v2 flex-col-el transition"
  >
    <div
      :data-sid="col.sid"
      class="group snap-center flex-col-inner h-full w-full position-relative padding-20"
      :class="[`--${col.sid}--flex-col-padding`, {'!shadow-none': !canUpdatePages}, {'is-active': isActive || isFocus}]"
      :data-uid="col.uid"
      :data-highliter-uid="col.uid"
      :data-value="col.name"
      @click.stop="selectCol"
    >
      <input
        v-if="canUpdatePages"
        v-model="col.name"
        type="text"
        class="absolute top-0 left-0 z-builder-selection translate-y-[-20px]"
        :class="{'hidden': !(isActive || isFocus)}"
      >

      <div
        v-if="canUpdatePages"
        class="col-toolbar hidden items-center px-3 gap-4 h-[30px] rounded-top translate-y-[-30px] translate-x-[2px] absolute top-0 right-0 bg-[#3f51b5] group-hover:flex"
      >
        <delete-confirm
          title="Are you sure?"
          description="You are about to delete this column?"
          @confirm="() => $emit('delete')"
        >
          <template #activator="{on}">
            <button
              class="p-0 hover:opacity-80"
              v-on="on"
            >
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.66667 0.857178H5.33333C4.85469 0.857178 4.46667 1.24093 4.46667 1.71432V2.57146H1.21667C1.097 2.57146 1 2.6674 1 2.78575V3.21432C1 3.33267 1.097 3.42861 1.21667 3.42861H2.08333L3.1294 14.184C3.1509 14.4045 3.33876 14.5725 3.56273 14.5715H11.4425C11.6664 14.5725 11.8543 14.4045 11.8758 14.184L12.9167 3.42861H13.7833C13.903 3.42861 14 3.33267 14 3.21432V2.78575C14 2.6674 13.903 2.57146 13.7833 2.57146H10.5333V1.71432C10.5333 1.24093 10.1453 0.857178 9.66667 0.857178ZM12.0465 3.4286L11.0455 13.7143H3.95446L2.95346 3.4286H12.0465ZM9.66667 1.71432H5.33334V2.57147H9.66667V1.71432Z"
                  fill="#fff"
                />
                <path
                  d="M4.46667 2.57146V2.72146H4.61667V2.57146H4.46667ZM2.08333 3.42861L2.23263 3.41408L2.21945 3.27861H2.08333V3.42861ZM3.1294 14.184L2.9801 14.1986L2.98011 14.1986L3.1294 14.184ZM3.56273 14.5715V14.4215L3.56205 14.4215L3.56273 14.5715ZM11.4425 14.5715L11.4432 14.4215H11.4425V14.5715ZM11.8758 14.184L12.0251 14.1986L12.0251 14.1985L11.8758 14.184ZM12.9167 3.42861V3.27861H12.7805L12.7674 3.41416L12.9167 3.42861ZM10.5333 2.57146H10.3833V2.72146H10.5333V2.57146ZM11.0455 13.7143V13.8643H11.1816L11.1948 13.7288L11.0455 13.7143ZM12.0465 3.4286L12.1958 3.44313L12.2118 3.2786H12.0465V3.4286ZM3.95446 13.7143L3.80517 13.7288L3.81835 13.8643H3.95446V13.7143ZM2.95346 3.4286V3.2786H2.78816L2.80417 3.44313L2.95346 3.4286ZM5.33334 1.71432V1.56432H5.18334V1.71432H5.33334ZM9.66667 1.71432H9.81667V1.56432H9.66667V1.71432ZM5.33334 2.57147H5.18334V2.72147H5.33334V2.57147ZM9.66667 2.57147V2.72147H9.81667V2.57147H9.66667ZM5.33333 1.00718H9.66667V0.707178H5.33333V1.00718ZM4.61667 1.71432C4.61667 1.32533 4.93596 1.00718 5.33333 1.00718V0.707178C4.77341 0.707178 4.31667 1.15653 4.31667 1.71432H4.61667ZM4.61667 2.57146V1.71432H4.31667V2.57146H4.61667ZM1.21667 2.72146H4.46667V2.42146H1.21667V2.72146ZM1.15 2.78575C1.15 2.7518 1.17828 2.72146 1.21667 2.72146V2.42146C1.01573 2.42146 0.85 2.583 0.85 2.78575H1.15ZM1.15 3.21432V2.78575H0.85V3.21432H1.15ZM1.21667 3.27861C1.17828 3.27861 1.15 3.24827 1.15 3.21432H0.85C0.85 3.41707 1.01573 3.57861 1.21667 3.57861V3.27861ZM2.08333 3.27861H1.21667V3.57861H2.08333V3.27861ZM3.2787 14.1695L2.23263 3.41408L1.93404 3.44313L2.9801 14.1986L3.2787 14.1695ZM3.56205 14.4215C3.41418 14.4221 3.29254 14.3115 3.27869 14.1695L2.98011 14.1986C3.00926 14.4975 3.26333 14.7228 3.56342 14.7215L3.56205 14.4215ZM11.4425 14.4215H3.56273V14.7215H11.4425V14.4215ZM11.7265 14.1695C11.7127 14.3115 11.591 14.4221 11.4432 14.4215L11.4418 14.7215C11.7419 14.7228 11.9959 14.4975 12.0251 14.1986L11.7265 14.1695ZM12.7674 3.41416L11.7265 14.1696L12.0251 14.1985L13.066 3.44305L12.7674 3.41416ZM13.7833 3.27861H12.9167V3.57861H13.7833V3.27861ZM13.85 3.21432C13.85 3.24827 13.8217 3.27861 13.7833 3.27861V3.57861C13.9843 3.57861 14.15 3.41707 14.15 3.21432H13.85ZM13.85 2.78575V3.21432H14.15V2.78575H13.85ZM13.7833 2.72146C13.8217 2.72146 13.85 2.7518 13.85 2.78575H14.15C14.15 2.583 13.9843 2.42146 13.7833 2.42146V2.72146ZM10.5333 2.72146H13.7833V2.42146H10.5333V2.72146ZM10.3833 1.71432V2.57146H10.6833V1.71432H10.3833ZM9.66667 1.00718C10.064 1.00718 10.3833 1.32533 10.3833 1.71432H10.6833C10.6833 1.15653 10.2266 0.707178 9.66667 0.707178V1.00718ZM11.1948 13.7288L12.1958 3.44313L11.8972 3.41407L10.8962 13.6998L11.1948 13.7288ZM3.95446 13.8643H11.0455V13.5643H3.95446V13.8643ZM2.80417 3.44313L3.80517 13.7288L4.10376 13.6998L3.10276 3.41407L2.80417 3.44313ZM12.0465 3.2786H2.95346V3.5786H12.0465V3.2786ZM5.33334 1.86432H9.66667V1.56432H5.33334V1.86432ZM5.48334 2.57147V1.71432H5.18334V2.57147H5.48334ZM9.66667 2.42147H5.33334V2.72147H9.66667V2.42147ZM9.51667 1.71432V2.57147H9.81667V1.71432H9.51667Z"
                  fill="#fff"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.71673 12.4192H7.2834C7.22587 12.4195 7.17062 12.397 7.12994 12.3567C7.08926 12.3165 7.0665 12.2618 7.06674 12.2049V4.88494C7.06674 4.76659 7.16374 4.67065 7.2834 4.67065H7.71673C7.83639 4.67065 7.9334 4.76659 7.9334 4.88494V12.2049C7.93363 12.2618 7.91088 12.3165 7.87019 12.3567C7.82951 12.397 7.77427 12.4195 7.71673 12.4192ZM6.0016 12.4057L5.56827 12.4306C5.44902 12.4374 5.34649 12.3479 5.3386 12.23L4.84374 4.92544C4.83994 4.86881 4.8591 4.81301 4.897 4.77039C4.93489 4.72776 4.98839 4.70182 5.04567 4.6983L5.479 4.67258C5.59858 4.66525 5.70165 4.75492 5.70953 4.87316L6.2044 12.1777C6.21183 12.2957 6.12167 12.3975 6.00247 12.4057H6.0016ZM9.43185 12.4306L8.99852 12.4057H8.99766C8.87845 12.3975 8.78829 12.2957 8.79572 12.1777L9.29059 4.87316C9.29847 4.75492 9.40154 4.66525 9.52112 4.67259L9.95445 4.6983C10.0117 4.70182 10.0652 4.72776 10.1031 4.77039C10.141 4.81301 10.1602 4.86881 10.1564 4.92544L9.66152 12.23C9.65363 12.3479 9.55111 12.4374 9.43185 12.4306Z"
                  fill="#fff"
                />
                <path
                  d="M7.2834 12.4192V12.2692L7.28281 12.2692L7.2834 12.4192ZM7.71673 12.4192L7.71733 12.2692H7.71673V12.4192ZM7.06674 12.2049L7.21674 12.2056V12.2049H7.06674ZM7.9334 12.2049H7.7834L7.7834 12.2056L7.9334 12.2049ZM5.56827 12.4306L5.55968 12.2808L5.55967 12.2808L5.56827 12.4306ZM6.0016 12.4057V12.2555L5.99301 12.256L6.0016 12.4057ZM5.3386 12.23L5.48827 12.22L5.48826 12.2199L5.3386 12.23ZM4.84374 4.92544L4.69407 4.93548L4.69408 4.93558L4.84374 4.92544ZM4.897 4.77039L5.0091 4.87005L5.0091 4.87005L4.897 4.77039ZM5.04567 4.6983L5.03678 4.54856L5.03646 4.54858L5.04567 4.6983ZM5.479 4.67258L5.48789 4.82232L5.48819 4.8223L5.479 4.67258ZM5.70953 4.87316L5.55987 4.88314L5.55988 4.88329L5.70953 4.87316ZM6.2044 12.1777L6.3541 12.1683L6.35406 12.1676L6.2044 12.1777ZM6.00247 12.4057V12.5561L6.01282 12.5554L6.00247 12.4057ZM8.99852 12.4057L9.00713 12.2557H8.99852V12.4057ZM9.43185 12.4306L9.44045 12.2808L9.44044 12.2808L9.43185 12.4306ZM8.99766 12.4057L8.98728 12.5557H8.99766V12.4057ZM8.79572 12.1777L8.64606 12.1676L8.64602 12.1683L8.79572 12.1777ZM9.29059 4.87316L9.44025 4.8833L9.44026 4.88314L9.29059 4.87316ZM9.52112 4.67259L9.51193 4.8223L9.51224 4.82232L9.52112 4.67259ZM9.95445 4.6983L9.96366 4.54858L9.96334 4.54856L9.95445 4.6983ZM10.1031 4.77039L9.99102 4.87005L9.99102 4.87005L10.1031 4.77039ZM10.1564 4.92544L10.306 4.93558L10.3061 4.93548L10.1564 4.92544ZM9.66152 12.23L9.51186 12.2199L9.51186 12.22L9.66152 12.23ZM7.2834 12.5692H7.71673V12.2692H7.2834V12.5692ZM7.02446 12.4634C7.09355 12.5317 7.18701 12.5696 7.284 12.5692L7.28281 12.2692C7.26473 12.2693 7.2477 12.2622 7.23542 12.2501L7.02446 12.4634ZM6.91674 12.2043C6.91634 12.3018 6.95532 12.395 7.02446 12.4634L7.23542 12.2501C7.2232 12.238 7.21667 12.2219 7.21673 12.2056L6.91674 12.2043ZM6.91674 4.88494V12.2049H7.21674V4.88494H6.91674ZM7.2834 4.52065C7.08246 4.52065 6.91674 4.68219 6.91674 4.88494H7.21674C7.21674 4.85099 7.24502 4.82065 7.2834 4.82065V4.52065ZM7.71673 4.52065H7.2834V4.82065H7.71673V4.52065ZM8.0834 4.88494C8.0834 4.68219 7.91767 4.52065 7.71673 4.52065V4.82065C7.75512 4.82065 7.7834 4.85099 7.7834 4.88494H8.0834ZM8.0834 12.2049V4.88494H7.7834V12.2049H8.0834ZM7.97567 12.4634C8.04482 12.395 8.08379 12.3018 8.0834 12.2043L7.7834 12.2056C7.78347 12.2219 7.77694 12.238 7.76472 12.2501L7.97567 12.4634ZM7.71614 12.5692C7.81313 12.5696 7.90659 12.5317 7.97567 12.4634L7.76472 12.2501C7.75244 12.2622 7.73541 12.2693 7.71733 12.2692L7.71614 12.5692ZM5.57686 12.5803L6.01019 12.5555L5.99301 12.256L5.55968 12.2808L5.57686 12.5803ZM5.18894 12.24C5.20242 12.4415 5.37699 12.5918 5.57687 12.5803L5.55967 12.2808C5.52104 12.2831 5.49056 12.2543 5.48827 12.22L5.18894 12.24ZM4.69408 4.93558L5.18894 12.2402L5.48826 12.2199L4.99339 4.9153L4.69408 4.93558ZM4.78489 4.67072C4.72043 4.74324 4.68757 4.83851 4.69407 4.93548L4.9934 4.9154C4.99231 4.89911 4.99778 4.88278 5.0091 4.87005L4.78489 4.67072ZM5.03646 4.54858C4.93989 4.55452 4.84931 4.59827 4.78489 4.67072L5.0091 4.87005C5.02048 4.85726 5.03689 4.84912 5.05488 4.84802L5.03646 4.54858ZM5.47012 4.52285L5.03678 4.54856L5.05455 4.84804L5.48789 4.82232L5.47012 4.52285ZM5.8592 4.86318C5.84572 4.66106 5.67023 4.51057 5.46981 4.52287L5.48819 4.8223C5.52693 4.81993 5.55757 4.84878 5.55987 4.88314L5.8592 4.86318ZM6.35406 12.1676L5.85919 4.86302L5.55988 4.88329L6.05474 12.1879L6.35406 12.1676ZM6.01282 12.5554C6.21277 12.5415 6.36682 12.3701 6.3541 12.1683L6.0547 12.1872C6.05684 12.2213 6.03057 12.2534 5.99211 12.2561L6.01282 12.5554ZM6.0016 12.5557H6.00247V12.2557H6.0016V12.5557ZM8.98993 12.5555L9.42326 12.5803L9.44044 12.2808L9.00711 12.256L8.98993 12.5555ZM8.99766 12.5557H8.99852V12.2557H8.99766V12.5557ZM8.64602 12.1683C8.6333 12.3701 8.78735 12.5415 8.9873 12.5554L9.00801 12.2561C8.96956 12.2534 8.94328 12.2213 8.94543 12.1872L8.64602 12.1683ZM9.14093 4.86302L8.64607 12.1676L8.94538 12.1879L9.44025 4.8833L9.14093 4.86302ZM9.53031 4.52287C9.32989 4.51057 9.1544 4.66106 9.14092 4.86318L9.44026 4.88314C9.44255 4.84878 9.47319 4.81993 9.51193 4.8223L9.53031 4.52287ZM9.96334 4.54856L9.53001 4.52285L9.51224 4.82232L9.94557 4.84804L9.96334 4.54856ZM10.2152 4.67073C10.1508 4.59827 10.0602 4.55452 9.96366 4.54858L9.94525 4.84802C9.96323 4.84912 9.97965 4.85726 9.99102 4.87005L10.2152 4.67073ZM10.3061 4.93548C10.3126 4.83851 10.2797 4.74324 10.2152 4.67072L9.99102 4.87005C10.0023 4.88278 10.0078 4.89911 10.0067 4.9154L10.3061 4.93548ZM9.81118 12.2402L10.306 4.93558L10.0067 4.9153L9.51186 12.2199L9.81118 12.2402ZM9.42326 12.5803C9.62313 12.5918 9.7977 12.4415 9.81119 12.24L9.51186 12.22C9.50956 12.2543 9.47908 12.2831 9.44045 12.2808L9.42326 12.5803Z"
                  fill="#fff"
                />
              </svg>
            </button>
          </template>
        </delete-confirm>
        <button
          class="p-0 hover:opacity-80"
          @click="() => $emit('copy')"
        >
          <svg
            width="14"
            height="13"
            viewBox="0 0 14 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.31857 12.5714H2.31857C1.57657 12.5714 0.972412 11.9956 0.972412 11.2885V4.10431C0.972412 3.39717 1.57657 2.82141 2.31857 2.82141H2.85703C3.00564 2.82141 3.12626 2.93636 3.12626 3.07799C3.12626 3.21962 3.00564 3.33457 2.85703 3.33457H2.31857C1.87326 3.33457 1.51087 3.67992 1.51087 4.10431V11.2885C1.51087 11.7129 1.87326 12.0583 2.31857 12.0583H9.31857C9.76387 12.0583 10.1263 11.7129 10.1263 11.2885V10.7754C10.1263 10.6337 10.2469 10.5188 10.3955 10.5188C10.5441 10.5188 10.6647 10.6337 10.6647 10.7754V11.2885C10.6647 11.9956 10.0606 12.5714 9.31857 12.5714Z"
              fill="#6E747A"
              stroke="#fff"
              stroke-width="0.3"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.31851 2.99288C1.66461 2.99288 1.14466 3.49877 1.14466 4.10435V11.2886C1.14466 11.8941 1.66461 12.4 2.31851 12.4H9.31851C9.97241 12.4 10.4924 11.8941 10.4924 11.2886V10.7754C10.4924 10.7353 10.4559 10.6902 10.3954 10.6902C10.3349 10.6902 10.2985 10.7353 10.2985 10.7754V11.2886C10.2985 11.8145 9.85192 12.2297 9.31851 12.2297H2.31851C1.7851 12.2297 1.33851 11.8145 1.33851 11.2886V4.10435C1.33851 3.57841 1.7851 3.16318 2.31851 3.16318H2.85697C2.91749 3.16318 2.9539 3.11811 2.9539 3.07803C2.9539 3.03795 2.91749 2.99288 2.85697 2.99288H2.31851ZM0.800049 4.10435C0.800049 3.29566 1.48841 2.65002 2.31851 2.65002H2.85697C3.09369 2.65002 3.29851 2.83485 3.29851 3.07803C3.29851 3.32122 3.09369 3.50604 2.85697 3.50604H2.31851C1.9613 3.50604 1.68313 3.78152 1.68313 4.10435V11.2886C1.68313 11.6114 1.96131 11.8869 2.31851 11.8869H9.31851C9.67572 11.8869 9.9539 11.6114 9.9539 11.2886V10.7754C9.9539 10.5322 10.1587 10.3474 10.3954 10.3474C10.6322 10.3474 10.837 10.5322 10.837 10.7754V11.2886C10.837 12.0972 10.1486 12.7429 9.31851 12.7429H2.31851C1.48841 12.7429 0.800049 12.0972 0.800049 11.2886V4.10435Z"
              fill="#fff"
              stroke="#fff"
              stroke-width="0.3"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.59135 9.57141H11.6995C12.4647 9.57141 13.0877 9.01041 13.0877 8.32141V1.82141C13.0877 1.13241 12.4647 0.571411 11.6995 0.571411H5.59135C4.82616 0.571411 4.20312 1.13241 4.20312 1.82141V8.32141C4.20312 9.01041 4.82616 9.57141 5.59135 9.57141ZM4.75841 1.82141C4.75841 1.40791 5.13212 1.07141 5.59135 1.07141H11.6995C12.1587 1.07141 12.5325 1.40791 12.5325 1.82141V8.32141C12.5325 8.73491 12.1587 9.07141 11.6995 9.07141H5.59135C5.13212 9.07141 4.75841 8.73491 4.75841 8.32141V1.82141Z"
              fill="#6E747A"
              stroke="#fff"
              stroke-width="0.3"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.59129 0.742882C4.90469 0.742882 4.37538 1.24282 4.37538 1.82145V8.32145C4.37538 8.90008 4.90469 9.40002 5.59129 9.40002H11.6995C12.3861 9.40002 12.9154 8.90008 12.9154 8.32145V1.82145C12.9154 1.24282 12.3861 0.742882 11.6995 0.742882H5.59129ZM4.03076 1.82145C4.03076 1.02209 4.74752 0.400024 5.59129 0.400024H11.6995C12.5432 0.400024 13.26 1.02209 13.26 1.82145V8.32145C13.26 9.12082 12.5432 9.74288 11.6995 9.74288H5.59129C4.74752 9.74288 4.03076 9.12082 4.03076 8.32145V1.82145ZM4.58605 1.82145C4.58605 1.29759 5.05348 0.900024 5.59129 0.900024H11.6995C12.2373 0.900024 12.7047 1.29759 12.7047 1.82145V8.32145C12.7047 8.84532 12.2373 9.24288 11.6995 9.24288H5.59129C5.05348 9.24288 4.58605 8.84532 4.58605 8.32145V1.82145ZM5.59129 1.24288C5.21065 1.24288 4.93067 1.51832 4.93067 1.82145V8.32145C4.93067 8.62458 5.21065 8.90002 5.59129 8.90002H11.6995C12.0801 8.90002 12.3601 8.62458 12.3601 8.32145V1.82145C12.3601 1.51832 12.0801 1.24288 11.6995 1.24288H5.59129Z"
              fill="#6E747A"
              stroke="#fff"
              stroke-width="0.3"
            />
          </svg>
        </button>
      </div>

      <background-slider-v2
        :options="col.backgroundSlider"
        :class="`--${col.sid}--bg block-bg inherit-radius`"
      />

      <div
        class="block-bg inherit-radius"
        :class="`--${col.sid}--bg`"
        :aria-label="col.bg_alt || undefined"
      />

      <div
        class="el-overlay inherit-radius"
      />

      <div
        class="block-bg flex overflow-hidden"
        :class="`--lottie-container-${col.sid}`"
      >
        <button-lottie-icon
          v-if="col.lottie"
          :config="col"
        />
      </div>

      <img
        class="float-image-wrapper"
        alt="Float Image"
      >

      <shape-divider
        :config="col"
      />

      <div
        class="transitioner h-min-[100px] h-100"
        :data-value="col.name"
      >
        <elements
          v-model="col.elements"
          :class="['flex-col-placeholder d-cont d-flex flex-column w-100 h-100', `--${col.sid}--flex-col`]"
          :classes="`--${col.sid}--col-content w-100 h-100 col-content`"
          drag-height="100px"
          :put="['elements', 'rows']"
          :sub-el-props="subElProps"
          @flow="handleFlow"
        />
      </div>

      <div
        v-if="isDrag"
        class="position-absolute top-0 left-0 w-100 h-100 z-builder-selection"
      />

      <div
        v-show="absolute"
        ref="move"
        class="move-col absolute top-0 left-0 z-builder-selection"
        :class="{'hidden': !(isActive || isFocus), 'group-hover:block': !(isActive || isFocus), 'block': (isActive || isFocus)}"
        @mouseenter="isHover = true"
        @mouseleave="isHover = false"
      >
        <svg
          class="cursor-move"
          fill="none"
          height="14"
          viewBox="0 0 14 14"
          width="14"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.32215 3.37761C8.54706 3.60252 8.91171 3.60252 9.13661 3.37762C9.36152 3.15271 9.36152 2.78806 9.13661 2.56316L7.40889 0.835428C7.30088 0.727424 7.1544 0.666748 7.00166 0.666748C6.84892 0.666748 6.70243 0.727424 6.59443 0.835428L4.8667 2.56316C4.64179 2.78806 4.64179 3.15271 4.8667 3.37761C5.09161 3.60252 5.45625 3.60252 5.68116 3.37761L6.42575 2.63303V5.27402C6.42575 5.59209 6.68359 5.84993 7.00166 5.84993C7.31972 5.84993 7.57757 5.59209 7.57757 5.27402V2.63303L8.32215 3.37761Z"
            fill="#5e5e5e"
          />
          <path
            d="M6.59443 13.1681C6.70243 13.2761 6.84892 13.3367 7.00166 13.3367C7.1544 13.3367 7.30088 13.2761 7.40889 13.1681L9.13661 11.4403C9.36152 11.2154 9.36152 10.8508 9.13661 10.6259C8.91171 10.401 8.54706 10.401 8.32215 10.6259L7.57757 11.3705V8.72948C7.57757 8.41141 7.31972 8.15357 7.00166 8.15357C6.68359 8.15357 6.42575 8.41141 6.42575 8.72948V11.3705L5.68116 10.6259C5.45625 10.401 5.09161 10.401 4.8667 10.6259C4.6418 10.8508 4.6418 11.2154 4.8667 11.4403L6.59443 13.1681Z"
            fill="#5e5e5e"
          />
          <path
            d="M3.37752 5.68125C3.60243 5.45634 3.60243 5.0917 3.37752 4.86679C3.15262 4.64189 2.78797 4.64189 2.56306 4.86679L0.835336 6.59452C0.727332 6.70252 0.666656 6.84901 0.666656 7.00175C0.666656 7.15449 0.727333 7.30097 0.835337 7.40898L2.56306 9.13671C2.78797 9.36161 3.15262 9.36161 3.37752 9.13671C3.60243 8.9118 3.60243 8.54715 3.37752 8.32225L2.63293 7.57766H5.27393C5.592 7.57766 5.84984 7.31982 5.84984 7.00175C5.84984 6.68368 5.592 6.42584 5.27393 6.42584H2.63293L3.37752 5.68125Z"
            fill="#5e5e5e"
          />
          <path
            d="M11.3704 7.57766L10.6258 8.32225C10.4009 8.54715 10.4009 8.9118 10.6258 9.13671C10.8507 9.36161 11.2153 9.36161 11.4402 9.13671L13.168 7.40898C13.276 7.30097 13.3367 7.15449 13.3367 7.00175C13.3367 6.84901 13.276 6.70252 13.168 6.59452L11.4402 4.86679C11.2153 4.64189 10.8507 4.64189 10.6258 4.86679C10.4009 5.0917 10.4009 5.45634 10.6258 5.68125L11.3704 6.42584H8.72938C8.41132 6.42584 8.15347 6.68368 8.15347 7.00175C8.15347 7.31982 8.41132 7.57766 8.72938 7.57766H11.3704Z"
            fill="#5e5e5e"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import ResolutionMixin from '@/components/mixins/ResolutionMixin'
import BorderMixin from '@/components/mixins/BorderMixin'
import Elements from '@/components/builder/utils/Elements/Elements'
import BackgroundMixin from '@/components/mixins/BackgroundMixin'
import Animations from '@/components/mixins/Animations'
import DragMixin from '@/components/editor/mixins/DragMixin'
import shortid from 'shortid'
import FlexScrollMixin from '@/components/builder/sections/utils/el-inline/flex-mixins/FlexScrollMixin'
import {mapGetters, mapState} from 'vuex'
import BackgroundSliderV2 from '@/components/builder/utils/BackgroundSliderV2'
import ShapeDivider from '@/components/editor/components/shape-divider/ShapeDivider'
import { generateSID, getStylesheetEl} from '@/utils/useStylesheet'
import DeleteConfirm from '@/components/editor/modals/DeleteConfirm.vue'
import StickyBlock from '@/mixins/StickyBlock'
import ButtonLottieIcon from '@/components/builder/elements/9.icon/ButtonLottieIcon.vue'

export default {
  name: 'FlexWrapperColV2',
  components: {ButtonLottieIcon, DeleteConfirm, ShapeDivider, BackgroundSliderV2, Elements},
  mixins: [ResolutionMixin, BorderMixin, BackgroundMixin, Animations, DragMixin, FlexScrollMixin, StickyBlock],
  props: {
    section: {
      type: Object,
      required: true
    },
    subElProps: {
      type: Object,
      required: false
    },
    col: {
      type: Object,
      required: true
    },
    originalCol: {
      default: null
    },
    mod: {
      type: String,
      default: 'flex-column-mod-v2'
    },
    index: {
      type: Number,
      required: true
    },
    customBackOptions: {
      type: [Object, Boolean],
      default: () => false
    }
  },
  data () {
    return {
      isHover: false,
      isActive: false,
      isFocus: false
    }
  },
  computed: {
    ...mapState('editor', {
      currentSubjectConfig: state => state.config,
      pickSubject: state => state.pickSubject
    }),
    ...mapState('pages', {
      page: state => state.page
    }),
    ...mapGetters('projects', {
      checkPermissions: 'checkPermissions'
    }),
    canUpdatePages () {
      return this.checkPermissions('pages.update')
    },
    absolute () {
      return _.get(this.col, ['absolute', this.resolutioner],false)
    },
    transformY () {
      return _.get(this.col, ['transformY', this.resolutioner], 0)
    },
    transformX () {
      return _.get(this.col, ['transformX', this.resolutioner], 0)
    },
    zIndex () {
      return _.get(this.col, ['zIndex', this.resolutioner], 0)
    },
    getPosition () {
      return {
        position: this.absolute ? 'absolute' : null,
        top: `${this.transformY}%`,
        left: `${this.transformX}%`,
        zIndex: this.zIndex || ''
      }
    },
    highlight () {
      return {
        boxShadow: this.col.highlight || this.isHover ? '0 0 0 2px #3f51b5' : null
      }
    },
    horizontalAlign () {
      return _.get(this.col, ['horizontalAlign', this.resolutioner], _.get(this.col, ['horizontalAlign', 'lg'], 'unset'))
    }
  },
  watch: {
    absolute (val) {
      if (val) {
        setTimeout(() => this.setInitialPosition(), 100)
      }
    }
  },
  mounted () {
    if (!this.col.sid) {
      const sid = generateSID(this.$el, this.page.css_hash)
      this.$set(this.col, 'sid', sid)
      getStylesheetEl().sheet.cssRules[0].insertRule(`.--${sid}--flex-col-el{width:100%;}`, getStylesheetEl().sheet.cssRules[0].length)
    }
  },
  created () {
    const col = this.originalCol ? this.originalCol : this.col
    if (!col.uid || [...document.querySelectorAll(`[data-uid="${col.uid}"]`)].filter(el => el !== this.$el).length) {
      this.$set(col, 'uid', shortid.generate())
    }

    if (!col._uid) {
      this.$set(col, '_uid', shortid.generate())
    }

    if (this.originalCol && !this.originalCol.sortIndex) {
      return this.$set(this.originalCol, 'sortIndex', {
        lg: this.index,
        md: this.index,
        sm: this.index
      })
    }

    if (this.col && !this.col.sortIndex) {
      this.$set(this.col, 'sortIndex', {
        lg: this.index,
        md: this.index,
        sm: this.index
      })
    }
  },
  methods: {
    handleFlow () {
      this.$store.commit('editor/ADD_ELEMENT_IN_STACK', {
        name: this.col.name,
        $el: this.$el,
        uid: this.section.uid,
        onClick: () => {
          this.$store.commit('editor/CLEAR_ELEMENTS_IN_STACK')
          this.$store.commit('editor/ADD_ELEMENT_IN_STACK', {
            name: this.col.name,
            $el: this.$el,
            uid: this.section.uid,
            onClick: () => {
            }
          })
          this.$emit('flow')
          this.$store.dispatch('editor/sectionSettings', {
            section: this.section,
            openedItem: this.mod,
            options: {
              subject: this.col,
              subjectIndex: this.index,
              title: this.col.name,
              back: () => {
                this.$store.dispatch('editor/sectionSettings', this.customBackOptions || {
                  section: this.section,
                  openedItem: 'flex-mod-v2'
                })
              }
            }
          })
        }
      })

      this.$emit('flow')
    },
    selectCol () {
      this.isFocus = true
      this.isActive = true

      const unFocus = () => {
        this.isFocus = false
        this.isActive = false
      }

      const unFocusOnClick = (e) => {
        if (e.target.closest('.flex-col-inner') !== this.$el.querySelector('.flex-col-inner')) {
          unFocus()
        }
      }

      const unFocusOnKey = () => {
        const $hoveredElements = document.querySelectorAll(':hover')
        if (!$hoveredElements.length) return

        if ($hoveredElements[$hoveredElements.length - 1].closest('.flex-col-inner') !== this.$el.querySelector('.flex-col-inner')) {
          unFocus()
          window.removeEventListener('keydown', unFocusOnKey, true)
        }
      }

      window.addEventListener('click', function click (e) {
        unFocusOnClick(e)
        window.removeEventListener('click', click, true)
        window.removeEventListener('keydown', unFocusOnKey)
      }, true)

      window.addEventListener('keydown', unFocusOnKey, true)

      if (this.pickSubject) {
        this.$set(this.currentSubjectConfig, 'pickedUid', this.col._uid || this.col.uid)
        return this.$store.commit('editor/PICK_SUBJECT', {pick: false, config: {}})
      }

      this.$store.commit('editor/CLEAR_ELEMENTS_IN_STACK')
      this.$store.commit('editor/ADD_ELEMENT_IN_STACK', {
        name: this.col.name,
        $el: this.$el,
        uid: this.section.uid,
        onClick: () => {}
      })
      this.$emit('flow')
      this.$store.dispatch('editor/sectionSettings', {
        section: this.section,
        openedItem: this.mod,
        options: {
          subject: this.col,
          subjectIndex: this.index,
          title: this.col.name,
          back: () => {
            this.$store.dispatch('editor/sectionSettings', this.customBackOptions || {
              section: this.section,
              openedItem: 'flex-mod-v2'
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.col-content {
  flex-direction: column;
  align-items: inherit;
  justify-content: inherit;
}

.col-hover-v2 {
  --height:auto;
  --width: 100%;
}

.flex-col-el {
  width: 100%;
}

.flex-col-inner::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-backdrop-filter: blur(var(--backdrop-filter-blur, 0));
  backdrop-filter: blur(var(--backdrop-filter-blur, 0));
  z-index: 0;
  pointer-events: none;
}

.flex-col-inner.is-active {
  & > .col-toolbar {
    display: flex;
  }

  & > .move-col {
    display: block;
  }

  & > input {
    width: 200px;
    height: 30px;
    background: #3f51b5;
    display: flex;
    align-items: center;
    color: #fff;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 11px;
    position: absolute;
    top: 0;
    left: -2px;
    padding-left: 15px;
    transform: translateY(-100%);
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    z-index: calc(var(--z-builder-selection, 130) + 2);
  }

  box-shadow: 0 0 0 2px #3f51b5;
}
</style>